import React from 'react';

const FormText = ({ children, error }) => (
  <small style={{ color: error ? '#d32f2f' : '#6c757d', fontSize: '11px', display: 'block', marginTop: '2px' }}>
    {children}
  </small>
);

export default FormText;
